import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";
import { DomUtil } from "../../util/DomUtil";
import { EventUtil } from "../../util/EventUtil";
import { LandingCardLoader } from "../genericLanding/LandingCardLoader";

export class MeetingCalendarFilter extends Component {

  public _sortElements: HTMLElement[];

  constructor(element: HTMLElement, context: PageContext) {
    super(element, context);

    const query = DomUtil.queryAll.bind(null, element);
    this._sortElements = query(".sort-type");

    this._sortElements.forEach(ct =>
      ct.addEventListener(
        "click",
        () => this.handleSortElementClick(ct)));
  }

  public handleSortElementClick(e: HTMLElement): void {
    const sortOrder = e.getAttribute("data-sort") ?? "";
    console.log("sorting by: " + sortOrder);
    this.toggleActiveState(e);

    e.dispatchEvent(
      EventUtil.createCustomEvent(LandingCardLoader.LoadFilteredPageEvent,
        sortOrder));
  }

  public toggleActiveState(e: HTMLElement): void {
    this._sortElements.forEach(ct =>
      ct.classList.remove("active"));
      e.classList.add("active");
  }
}

ComponentFactory.registerComponent("MeetingCalendarFilter",
  MeetingCalendarFilter);
